import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { cleanedParams } from "../../plugins/utils";
import {
  CoachInfoResponse,
  CoachParams,
  CoachResponse,
  CoachScheduleResponse,
} from "./data";
import { apiGetCoaches, apiGetCoachInfo, apiGetCoachSchedule } from "./service";

export const useGetCoaches = (params: CoachParams, options: any) => {
  const queryKeyArr = [
    queryKey.COACH_LIST,
    ...Object.values(cleanedParams(params)),
  ];

  return useQuery<CoachResponse[]>({
    queryKey: queryKeyArr,
    queryFn: () =>
      apiGetCoaches(params).then(
        (res: ApiResponse<CoachResponse[]>) => res.data.data
      ),
    ...options,
  });
};

export const useGetCoachInfo = (params: any, options: any) => {
  const queryKeyArr = [
    queryKey.COACH_INFO,
    ...Object.values(cleanedParams(params)),
  ];

  return useQuery<CoachInfoResponse>({
    queryKey: queryKeyArr,
    queryFn: () =>
      apiGetCoachInfo(params).then(
        (res: ApiResponse<CoachInfoResponse>) => res.data.data
      ),
    ...options,
  });
};

export const useGetCoachSchedule = (params: any, options: any) => {
  const queryKeyArr = [
    queryKey.COACH_SCHEDULE,
    ...Object.values(cleanedParams(params)),
  ];
  return useQuery<CoachScheduleResponse[]>({
    queryKey: queryKeyArr,
    queryFn: () =>
      apiGetCoachSchedule(params).then(
        (res: ApiResponse<CoachScheduleResponse[]>) => res.data.data
      ),
    ...options,
  });
};
